import React from 'react';
import { AuthorizationsService } from '../../../../services/patientmr/authorizations.service';
import { PAPayerType } from '../../../../dtos/patientmr/authorizations.dto';

interface PayerChipProps {
  payerType: PAPayerType | string;
  payerName: string;
}

export const PayerChip: React.FC<PayerChipProps> = ({ payerType, payerName }) => {
  const styles = AuthorizationsService.getPayerChipStyles(payerType);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${styles}`}>
      {payerName}
    </span>
  );
};

export default PayerChip;
